<template>
  <section class="landing-page">
    <header class="header-landing">
      <nav
        class="navbar is-light"
        role="navigation"
        aria-label="main navigation"
      >
        <div class="container">
          <div class="navbar-brand">
            <a
              class="navbar-item"
              href="https://www.solem.cl/"
            >
              <img
                class="logo"
                src="@/images/landing/logo.svg"
                alt=""
              >
            </a>
            <a
              role="button"
              class="navbar-burger titlemobile"
              aria-label="menu"
              aria-expanded="false"
              data-target="navbarBasicExample"
            >
              {{ text.title }}
            </a>
          </div>
          <div
            id="navbarBasicExample"
            class="navbar-menu"
          >
            <div class="navbar-end">
              <div class="navbar-item titlenav">
                {{ text.title }}
              </div>
            </div>
          </div>
        </div>
      </nav>
    </header>
    <div class="main-landing">
      <section class="section one is-flex is-justify-content-center">
        <div class="container">
          <div class="columns intro  is-desktop">
            <div class="column is-align-content-center intro">
              <h1 class="title mb-4">
                {{ text.title }}
              </h1>
              <p class="subtitle">
                {{ text.subtitle }}
              </p>
              <div class="buttons">
                <button
                  class="button"
                  @click="access"
                >
                  {{ text.btnAccess }}
                </button>
              </div>
            </div>
            <div class="column imgbox is-flex is-justify-content-end">
              <img
                class="img"
                src="@/images/landing/soporte.png"
                alt=""
              >
            </div>
          </div>
        </div>
      </section>
      <section class="section is-flex is-justify-content-center">
        <div class="container">
          <div class="columns is-desktop">
            <div class="column title">
              <h2 class="title s2">
                {{ text.section_one.title }}
              </h2>
            </div>
            <div class="column cards1">
              <div class="cards">
                <div class="card">
                  <div class="card-content">
                    <div class="number uno">
                      <span>{{ text.cards.card1.number }}</span>
                    </div>
                    <div class="content">
                      {{ text.cards.card1.content }}
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-content">
                    <div class="number dos">
                      <span>{{ text.cards.card2.number }}</span>
                    </div>
                    <div class="content">
                      {{ text.cards.card2.content }}
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-content">
                    <div class="number tres">
                      <span>{{ text.cards.card3.number }}</span>
                    </div>
                    <div class="content">
                      {{ text.cards.card3.content }}
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-content">
                    <div class="number cuatro">
                      <span>{{ text.cards.card4.number }}</span>
                    </div>
                    <div class="content">
                      {{ text.cards.card4.content }}
                    </div>
                  </div>
                </div>
                <div class="card">
                  <div class="card-content">
                    <div class="number cinco">
                      <span>{{ text.cards.card5.number }}</span>
                    </div>
                    <div class="content">
                      {{ text.cards.card5.content }}
                    </div>
                  </div>
                </div>
                <div class="card" />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="section two ">
        <div class="container">
          <div class="columns is-desktop">
            <div class="column is-flex is-justify-content-center">
              <h2 class="title2 mb-6">
                {{ text.section_two.title }}
              </h2>
            </div>
          </div>
        </div>
        <div class="container">
          <div class="columns cards2">
            <div class="column">
              <div class="card proceso">
                <div class="card-content">
                  <div class="content">
                    <img
                      src="@/images/landing/evidencia.svg"
                      alt=""
                    >
                    <h3>{{ text.cards_two.card1.title }}</h3>
                    <span>{{ text.cards_two.card1.content }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="column">
              <div class="card proceso">
                <div class="card-content">
                  <div class="content">
                    <img
                      src="@/images/landing/proyecto.svg"
                      alt=""
                    >
                    <h3>{{ text.cards_two.card2.title }}</h3>
                    <span>{{ text.cards_two.card2.content }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="column">
              <div class="card proceso">
                <div class="card-content">
                  <div class="content">
                    <img
                      src="@/images/landing/ticket.svg"
                      alt=""
                    >
                    <h3>{{ text.cards_two.card3.title }}</h3>
                    <span>{{ text.cards_two.card1.content }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <!-- <footer class="is-flex is-justify-content-center">
      <p>{{ text.title }} SOLEM 2024</p>
    </footer> -->
  </section>
</template>

<script>
export default {
  name: 'Landing',
  computed: {
    text () {
      return this.$root.globalText[this.$root.language].landing
    }
  },
  created () {
    document.title = 'Autoatención'
    console.log('keycloak', this.$keycloak)
  },
  methods: {
    access () {
      this.$keycloak.login({})
    }
  }
}
</script>
